import React, { useState, useEffect } from 'react';
import apiService from '../../apiService';
import OverviewTab from './tabs/OverviewTab';
import ByActivityTab from './tabs/ByActivityTab';
import LedgerTab from './tabs/LedgerTab';
import TreasuryTab from './tabs/TreasuryTab';
import ReconciliationTab from './tabs/ReconciliationTab';
import AuditTab from './tabs/AuditTab';
import ExpensesTab from './tabs/ExpensesTab';
import IncomeStatementTab from './tabs/IncomeStatementTab';
import BalanceSheetTab from './tabs/BalanceSheetTab';
import AntiFraudTab from './tabs/AntiFraudTab';
import SettingsTab from './tabs/SettingsTab';

// Sous-onglets, regroupés. Phase 1 = pilotage ; Phase 2 = comptabilité & contrôle.
const TABS = [
  { key: 'overview', label: "Vue d'ensemble", Comp: OverviewTab, group: 'Pilotage' },
  { key: 'by-activity', label: 'Revenus par activité', Comp: ByActivityTab, group: 'Pilotage' },
  { key: 'ledger', label: 'Grand-livre / Flux', Comp: LedgerTab, group: 'Pilotage' },
  { key: 'treasury', label: 'Trésorerie', Comp: TreasuryTab, group: 'Pilotage' },
  { key: 'reconciliation', label: 'Réconciliation', Comp: ReconciliationTab, group: 'Contrôle' },
  { key: 'audit', label: 'Audit financier', Comp: AuditTab, group: 'Contrôle' },
  { key: 'expenses', label: 'Dépenses', Comp: ExpensesTab, group: 'Comptabilité' },
  { key: 'income-statement', label: 'Compte de résultat', Comp: IncomeStatementTab, group: 'Comptabilité' },
  { key: 'balance-sheet', label: 'Bilan', Comp: BalanceSheetTab, group: 'Comptabilité' },
  { key: 'fraud', label: 'Anti-fraude', Comp: AntiFraudTab, group: 'Contrôle' },
  { key: 'settings', label: 'Paramètres', Comp: SettingsTab, group: 'Configuration' },
];

export default function FinancePilotagePage() {
  const [subtab, setSubtab] = useState('overview');
  const [currency, setCurrency] = useState('CDF');
  const [rate, setRate] = useState(2800);

  useEffect(() => {
    apiService.get('/admin/finance/rate', { userType: 'admin' })
      .then(res => { if (res?.currency?.usd_exchange_rate) setRate(res.currency.usd_exchange_rate); })
      .catch(() => {});
  }, []);

  const Active = TABS.find(t => t.key === subtab)?.Comp || OverviewTab;

  return (
    <div className="dashboard-content">
      {/* En-tête + sélecteur de devise */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem', marginBottom: '0.75rem' }}>
        <h1 className="page-title" style={{ margin: 0 }}>Pilotage financier</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <span style={{ fontSize: '0.75rem', color: '#5C636E' }}>1 USD = {rate.toLocaleString('fr-FR')} CDF</span>
          <div style={{ display: 'inline-flex', background: '#F4F5F7', borderRadius: '8px', padding: '3px' }}>
            {['CDF', 'USD'].map(c => (
              <button key={c} onClick={() => setCurrency(c)}
                style={{ padding: '0.35rem 0.9rem', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '0.8rem',
                  background: currency === c ? '#1E2229' : 'transparent', color: currency === c ? 'white' : '#414852' }}>
                {c}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Barre de sous-onglets */}
      <div style={{ display: 'flex', gap: '0.15rem', flexWrap: 'wrap', borderBottom: '2px solid #E9EBEF', marginBottom: '1.5rem' }}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => setSubtab(t.key)}
            style={{ padding: '0.6rem 0.9rem', border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem',
              color: subtab === t.key ? '#1E2229' : '#9AA0A8',
              borderBottom: subtab === t.key ? '2px solid #1E2229' : '2px solid transparent', marginBottom: '-2px' }}>
            {t.label}
          </button>
        ))}
      </div>

      <Active currency={currency} rate={rate} />
    </div>
  );
}
